import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import { CardWithTitle } from '@/components/ui/Surface/CardWithTitle';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { hotlineFormLayoutStyle } from '@/feature/hotline/component/HotlineFormLayout/style';
/**
 * 匿名ホットライン Form 入力・確認画面レイアウト
 */
export const HotlineFormLayout = (props) => {
    const { breadcrumbs, children, formTitle, pageTitle } = props;
    const style = hotlineFormLayoutStyle();
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(BandHead, Object.assign({ bgColor: 'primary', tagName: 'h1' }, { children: _jsx(ContentContainer, Object.assign({ className: style.pageTitleInner() }, { children: pageTitle })) })), _jsx(CardWithTitle, Object.assign({ className: style.cardWrap(), title: formTitle }, { children: children }))] }));
};
